// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
const mc = require('__libs/ModuleConstructor.js');
window.noUiSlider = require('nouislider');
mc.runVue(['Slider', 'Navigation', 'predictiveSelect']);

$('body').on('ajaxResponse', function() {
	mc.runVue(['selectList', 'Slider', 'Navigation', 'predictiveSelect']);
});

mc.runComponents(['rating']);
mc.runFooter();


// WEBPACK FOOTER //
// ./entries/all.js